import React from 'react';
import './howDoWeHelp.scss';
import {ReactComponent as ELEMENT_03} from "assets/about/elements/ab_element_03.svg";

const HowDoWeHelp = () => {
    return (
        <div className={'how-help'} id={'how-help'}>

            <ELEMENT_03 className={'how-help_element_03'}/>

            <div className={'how-help_wrapper max'} id={'how_it_works'}>
                <h1>How Do We Help?</h1>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Faucibus turpis felis sit ipsum lacinia est,
                    interdum accumsan. Consequat sem gravida nisl risus, enim facilisis ultrices. Scelerisque a feugiat
                    commodo tristique augue. Tellus nam vitae in et eget sagittis elementum. Tellus tristique pharetra,
                    aenean egestas velit augue tristique mauris. Vitae in lacinia morbi eros, gravida tempus, at
                    natoque.

                </p>
                <p>Ut suspendisse augue consectetur sodales urna. Nisl, fusce facilisi auctor ut dolor a, commodo.
                    Dictum penatibus elit quam mollis sed viverra vitae tristique. Tincidunt commodo vitae id amet, eget
                    vitae nec. Cras interdum donec amet ut tincidunt proin viverra. Eu mauris pellentesque consequat
                    convallis dolor tortor.</p>
                <p>
                    Commodo, ac rhoncus ornare ornare egestas netus elit. Scelerisque id justo, quis amet id duis nunc,
                    proin. In suspendisse cras a tristique laoreet convallis imperdiet ultricies auctor. Eget semper
                    elementum elementum enim ullamcorper convallis tincidunt amet, dis. Sed eu integer tristique lacus
                    viverra tempus non leo neque. Aliquam aenean commodo risus integer fermentum ornare accumsan.
                    Blandit proin amet mi hendrerit leo risus. Enim lobortis pretium, at tincidunt. Nibh proin nunc
                    augue lectus pellentesque pharetra.
                    Sed egestas ut nulla ut.
                </p>
            </div>
        </div>
    );
};

export default HowDoWeHelp;
